// 格式化数据
// num 传入数据  String || Number
// type 传入类型，如果需要处理特殊类型的数据 传数组或对象  String || Array || Object
// type Array [ retain, unit, unitPosition, formula ]
// type Array [ 2, '%', 'before'/'after', '*100' ]
// type Array [ 小数点后保留多少位, 单位, 单位位置, 额外计算公式 ]
// type Object { retain: 2, unit: '%', unitPosition: 'before'/'after', formula: '*100' }
const formatNum = (num, type = 'default') => {
  // 没数据
  if (num === '' || num === '-' || num === null || num === undefined || isNaN(num)) return '-';
  // 判断infinity
  if (num === Infinity) return '';
  // 格式化数据配置
  let formatConfig = null;
  if (typeof type === 'string') {
    switch (type) {
      case 'default': formatConfig = { retain: 0, unit: '', unitPosition: null, formula: null }; break;
      case 'money': formatConfig = { retain: 2, unit: '¥', unitPosition: 'before', formula: null }; break;
      case 'money$': formatConfig = { retain: 2, unit: '$', unitPosition: 'before', formula: null }; break;
      case 'rate': formatConfig = { retain: 1, unit: '%', unitPosition: 'after', formula: '*100' }; break;
      default: break;
    }
  }
  if (typeof type === 'object') {
    if (Array.isArray(type)) {
      formatConfig = {
        retain: type[0] || 0,
        unit: (type[1] && typeof type[1] === 'string') ? type[1] : null,
        unitPosition: (type[2] && typeof type[2] === 'string') ? type[2] : null,
        formula: (type[3] && typeof type[3] === 'string') ? type[3] : null
      }
    } else {
      formatConfig = {
        retain: type.retain || 0,
        unit: (type.unit && typeof type.unit === 'string') ? type.unit : null,
        unitPosition: (type.unitPosition && typeof type.unitPosition === 'string') ? type.unitPosition : null,
        formula: (type.formula && typeof type.formula === 'string') ? type.formula : null
      }
    }
  }
  if (!formatConfig) return '-';
  // 处理数据
  let data = Number(num);
  // 额外计算公式
  if (formatConfig.formula) {
    const countUnit = formatConfig.formula.substr(0, 1);
    const countData = Number(formatConfig.formula.substr(1));
    switch (countUnit) {
      case '+': data = data + countData; break;
      case '-': data = data - countData; break;
      case '*': data = data * countData; break;
      case '/': data = data / countData; break;
      default: break;
    }
    // 解决浮点数计算不准确问题
    const stringData = data.toString();
    if (stringData.indexOf('.') !== -1 && stringData.substr(stringData.indexOf('.') + 1) > formatConfig.retain + 2) {
      data = data.toFixed(formatConfig.retain + 2);
      data = Number(data);
    }
  }
  // 小数点保留后几位
  data = data.toFixed(formatConfig.retain);
  // 判断是否有小数点
  if (data.indexOf('.') !== -1) {
    // 保存小数点及小数点后几位数据  例: '.123'
    let decimal = data.substr(data.indexOf('.'));
    // 数据千分位  先将小数点后几位省略
    data = data.substr(0, data.indexOf('.')).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 加上小数点后几位
    data = data + decimal;
  } else {
    // 数据千分位
    data = data.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
  // 添加符号
  if (formatConfig.unit) {
    if (formatConfig.unitPosition === 'before') data = formatConfig.unit + data;
    if (formatConfig.unitPosition === 'after') data = data + formatConfig.unit;
  }
  return data;
}

export default formatNum;